import { type EditionsType } from '@app/client/common/structs/emoji/editions';

export const ACTION_SET_EDITIONS = 'ACTION_SET_EDITIONS';

export interface EditionsState {
    editions: EditionsType;
}

interface SetEditions {
    type: typeof ACTION_SET_EDITIONS;
    editions: EditionsType;
}

export type EditionsActionsTypes = SetEditions;
